import { Role } from 'types';
import { AiSettingsPage } from 'modules/ai-settings';
import { Login, ForgotPassword, ResetPassword } from 'modules/auth';
import { ChatPage } from 'modules/chat';
import { PrompthubPage, MyPromptsPage, PromptCasesPage } from 'modules/prompthub';
import { ConfluencePage } from 'modules/confluence';
import { GitPage } from 'modules/git';
import { YandexTrackerLayout, TasksTab, QueuesTab } from 'modules/yandex-tracker';
import { YandexWikiPage } from 'modules/yandex-wiki';
import { UrlSourcesPage } from 'modules/url-sources';
import ProjectsPage from 'modules/projects/ProjectsPage';
import ProjectForm from 'modules/projects/ProjectForm';
import RolesPage from 'modules/roles/RolesPage';
import RoleForm from 'modules/roles/RoleForm';
import UsersPage from 'modules/users/UsersPage';
import UserForm from 'modules/users/UserForm';
import { GeneralInformationPage } from 'modules/general-information';
import { SummarizerPage } from 'modules/summarizer';
import { TextComparePage } from 'modules/text-compare';
// import { ObfuscationPage } from 'modules/obfuscation';
import TechnicalTaskPage from 'modules/technical-task';
import JiraPage from 'modules/jira/JiraPage';
import { AnalyticsPage } from 'modules/analytics';
import { UserActionsPage } from 'modules/user-actions';
import BitrixLoadingPage from 'modules/bitrix/pages/BitrixLoadingPage';
import BitrixSuccessPage from 'modules/bitrix/pages/BitrixSuccessPage';
import SettingsPage from 'modules/settings';

export const routes = [
  {
    path: '/login',
    label: 'Авторизация',
    component: Login,
    public: true,
  },
  {
    path: '/forgot-password',
    label: 'Восстановление пароля',
    component: ForgotPassword,
    public: true,
  },
  {
    path: '/reset-password',
    label: 'Сброс пароля',
    component: ResetPassword,
    public: true,
  },
  {
    path: '/',
    redirect: '/chat',
    exact: true,
  },
  {
    path: '/chat',
    label: 'Чат с ИИ',
    icon: 'chat',
    component: ChatPage,
    isShowMenu: true,
    allRoles: true,
  },
  {
    path: '/prompthub',
    label: 'Хранилище промптов',
    icon: 'library_add',
    component: PrompthubPage,
    isShowMenu: false,
    allRoles: true,
  },
  {
    path: '/prompthub/my-prompts',
    label: 'Мои промпты',
    component: MyPromptsPage,
    isShowMenu: false,
  },
  {
    path: '/prompthub/cases',
    label: 'Кейсы промптов',
    component: PromptCasesPage,
    isShowMenu: false,
    adminOnly: true,
  },
  {
    path: '/business',
    label: 'Общая информация',
    icon: 'business',
    component: GeneralInformationPage,
    isShowMenu: true,
  },
  {
    path: '/ai-settings',
    label: 'Настройки ИИ',
    icon: 'settings',
    component: AiSettingsPage,
    isShowMenu: true,
  },
  {
    path: '/technical-task',
    label: 'ТЗ',
    icon: 'assignment',
    component: TechnicalTaskPage,
    isShowMenu: true,
  },
  // {
  //   path: '/estimation',
  //   label: 'Оценки',
  //   icon: 'calculate',
  //   component: EstimationListPage,
  //   isShowMenu: true,
  //   allRoles: true,
  // },
  // {
  //   path: '/estimation/create',
  //   label: 'Новая оценка',
  //   component: EstimationFormPage,
  //   allRoles: true,
  // },
  // {
  //   path: '/estimation/prompts',
  //   label: 'Системные промпты пресейла',
  //   component: PresalePromptsPage,
  //   allRoles: true,
  // },
  // {
  //   path: '/estimation/:id',
  //   label: 'Оценка',
  //   component: EstimationFormPage,
  //   allRoles: true,
  // },
  {
    path: '/integrations/bitrix/loading',
    component: BitrixLoadingPage,
    standalone: true,
  },
  {
    path: '/integrations/bitrix/success',
    component: BitrixSuccessPage,
    standalone: true,
  },
  {
    path: '/jira',
    label: 'Jira',
    icon: 'bug_report',
    component: JiraPage,
    isShowMenu: true,
  },
  {
    path: '/confluence',
    label: 'Confluence',
    icon: 'library_books',
    component: ConfluencePage,
    isShowMenu: true,
  },
  {
    path: '/git',
    label: 'Git',
    icon: 'code',
    component: GitPage,
    isShowMenu: true,
  },
  {
    path: '/url-sources',
    label: 'URL-источники',
    icon: 'language',
    component: UrlSourcesPage,
    isShowMenu: true,
    allRoles: true,
  },
  {
    path: '/summarizer',
    label: 'Саммаризатор',
    icon: 'summarize',
    component: SummarizerPage,
    isShowMenu: true,
  },
  {
    path: '/yandex/tracker',
    label: 'Яндекс Трекер',
    icon: 'article',
    component: YandexTrackerLayout,
    isShowMenu: false,
    requiredPermission: 'yandex',
    nested: [
      { path: 'tasks', component: TasksTab },
      { path: 'queues', component: QueuesTab },
    ],
  },
  {
    path: '/yandex/wiki',
    label: 'Яндекс Вики',
    icon: 'article',
    component: YandexWikiPage,
    isShowMenu: false,
    requiredPermission: 'yandex',
  },
  {
    path: '/projects',
    label: 'Проекты',
    icon: 'folder',
    component: ProjectsPage,
  },
  {
    path: '/projects/create',
    label: 'Создать проект',
    component: ProjectForm,
  },
  {
    path: '/projects/edit/:id',
    label: 'Редактировать проект',
    component: ProjectForm,
  },
  {
    path: '/users',
    label: 'Пользователи',
    icon: 'people',
    adminOnly: true,
    component: UsersPage,
    isShowMenu: true,
  },
  {
    path: '/users/create',
    label: 'Создать пользователя',
    adminOnly: true,
    component: UserForm,
  },
  {
    path: '/users/edit/:id',
    label: 'Редактировать пользователя',
    adminOnly: true,
    component: UserForm,
  },
  {
    path: '/roles',
    label: 'Роли',
    icon: 'security',
    adminOnly: true,
    component: RolesPage,
    isShowMenu: true,
  },
  {
    path: '/roles/create',
    label: 'Создать роль',
    adminOnly: true,
    component: RoleForm,
  },
  {
    path: '/roles/edit/:id',
    label: 'Редактировать роль',
    adminOnly: true,
    component: RoleForm,
  },
  {
    path: '/analytics',
    label: 'Аналитика',
    icon: 'bar_chart',
    component: AnalyticsPage,
    isShowMenu: true,
    adminOnly: true,
  },
  {
    path: '/user-actions',
    label: 'Журнал действий',
    icon: 'history',
    component: UserActionsPage,
    isShowMenu: true,
    adminOnly: true,
  },
  {
    path: '/compare',
    label: 'Сравнение текстов',
    icon: 'compare_arrows',
    component: TextComparePage,
    isShowMenu: true,
    allRoles: true,
  },
  {
    path: '/settings',
    label: 'Настройки',
    icon: '',
    component: SettingsPage,
    adminOnly: true,
  },
  // {
  //   path: '/obfuscation',
  //   label: 'Обфускация',
  //   icon: 'visibility_off',
  //   component: ObfuscationPage,
  //   isShowMenu: true,
  // },
];

/** Суперадмин: isAdmin + у выбранной роли пустой список пермишенов (доступ ко всем модулям в меню). */
export const isSuperadminRole = (userRole: Role | null | undefined, isAdmin: boolean): boolean =>
  Boolean(isAdmin && userRole && userRole.permissions.length === 0);

/**
 * Доступ к модулю по имени пермишена (как в initPermissions / чат-фильтрах).
 * Суперадмин — ко всем; иначе нужен явный пермишен.
 */
export const canAccessByPermission = (
  userRole: Role | null | undefined,
  isAdmin: boolean,
  permissionName: string
): boolean => {
  if (!userRole) return false;
  const allowed = userRole.permissions.map((p) => p.name);
  if (isSuperadminRole(userRole, isAdmin)) return true;
  return allowed.includes(permissionName);
};

export const getVisibleRoutes = (userRole: Role, isAdmin: boolean) => {
  if (!userRole) return [];

  const allowedRoutes = userRole.permissions.map((permission) => permission.name);

  // Суперадмин: согласовано с логикой isFilterAvailable в filterPermissions.js
  if (isSuperadminRole(userRole, isAdmin)) {
    return routes.filter((route) => route.isShowMenu === true && route.path !== '/');
  }

  return routes.filter((route) => {
    if (route.isShowMenu !== true || route.path === '/') {
      return false;
    }

    if (route.allRoles) {
      return true;
    }

    const routePath = route.path.startsWith('/') ? route.path.slice(1) : route.path;
    return allowedRoutes.includes(routePath);
  });
};

export const getAdminRoutes = (isAdmin: boolean) => {
  if (!isAdmin) return [];

  return routes.filter(
    (route) => route.isShowMenu === true && route.path !== '/' && route.adminOnly
  );
};
